import ApiService from '@/services/api.service';
import store from '@/globalvar.js';

const ProviderService = {
    getLookUp(UserId) {
        return ApiService.get(`/Providers/LookUp?UserId=${UserId}&IncludeTraining=true`);
    },
    getLookUpWOTraining(UserId) {
        //return ApiService.get(`/Providers/LookUp`);
        return ApiService.get(`/Providers/LookUp?UserId=${UserId}&IncludeTraining=false`);
    },

    getVisibleSettings() {
        return ApiService.get(`/Providers/VisibleSettings`);
    },

    async ensureVisibleSettings() {
        if (!store.state.providerVisibleSettingsLoaded) {
            const response = await ProviderService.getVisibleSettings();
            if (response.status == '200' && response.data) {
                store.commit('setProviderVisibleSettings', response.data);
            }
        }
        return store.state;
    },

    getFullProvidersNoTraining(parameter) {
        const params = {
            SearchCriteria: parameter.SearchCriteria,
            PageSize: parameter.PageSize,
            PageNumber: parameter.PageNumber
        };
        return ApiService.get(`/providers?IncludeTraining=true`, { params });
    },

    SelectProvider(code) {
        return ApiService.post(`/auth/provider/`, code);
    },

    SetUserRestrictions(data) {
        return ApiService.post(`/auth/restrictions/`, data);
    },

    get(id) {
        return ApiService.get(`/Providers/${id}`);
    },

    add(data) {
        return ApiService.post(`/Providers`, data);
    },

    delete(id) {
        return ApiService.delete(`/Providers/${id}`);
    },

    update(id, data) {
        return ApiService.put(`/Providers/${id}`, data);
    },

    checkDirectory(path) {
        return ApiService.get(`/Providers/directory?path=${encodeURIComponent(path)}`);
    },
};

export default ProviderService;
